export default "__VITE_ASSET__5ea6e6d2__"